import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { GrnRejectionReasonAdapter } from './dto/grn-rejection-reason.adapter';
import { GrnRejectionReason } from './grn-rejection-reason.entity';
import { GrnRejectionReasonsController } from './grn-rejection-reasons.controller';
import { GrnRejectionReasonsService } from './grn-rejection-reasons.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([GrnRejectionReason]),
  ],
  controllers: [GrnRejectionReasonsController],
  providers: [GrnRejectionReasonsService,GrnRejectionReasonAdapter,ApplicationExceptionHandler,LogsService]
})
export class GrnRejectionReasonsModule {}
